import React, { Component } from "react";
import Header from "@baxus/shared/dist/Components/Header";
import Routes from "./Router";
// import Header from "./Components/Header";
import Footer from "@baxus/shared/dist/Components/Footer";
import "./App.scss";

class App extends Component {
  render() {
    return (
      <div className="pageWrapper">
        <Header />
        {/* <Header /> */}
        <div id="main-content">
          <Routes />
        </div>
        <Footer />
      </div>
    );
  }
}

export default App;
